import { BaseIconProps } from "components/icons/IconFactory"
import { FC } from "react"


interface LightActionProps {
  icon: React.FC<BaseIconProps>
  label: string
  onClick?: () => void
  className?: string
  disabled?: boolean
}

export const LightAction: FC<LightActionProps> = ({ icon, label, onClick, className, disabled }) => {
  const Icon = icon
  return <button className={`${className} flex items-center group text-primary hover:text-primary/80 gap-1.5`} onClick={(e) => {
    if (!onClick)
      return
    e.stopPropagation()
    e.preventDefault()
    onClick()
  }}
    disabled={disabled}>
    <div className="flex-none w-3.5 h-3.5 mt-0.5 rounded-full border border-primary group-hover:border-primary/80">
      <Icon className="flex-wrap w-full" />
    </div>
    <p className="text-sm">{label}</p>
  </button>
}
